import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { getTerritories } from "@/utils/supabase/areaHelpers";
import { getAreaDisplayLabels, getAreaSummaryLabel } from "@/utils/areaSelection";

export function useAreaDisplay(selectedAreas: string[]) {
  const { data: territories = [] } = useQuery({
    queryKey: ["territories"],
    queryFn: getTerritories,
    staleTime: 5 * 60 * 1000,
  });

  const areaLabels = useMemo(
    () => getAreaDisplayLabels(territories, selectedAreas),
    [territories, selectedAreas]
  );

  const areaSummaryLabel = useMemo(
    () => getAreaSummaryLabel(areaLabels),
    [areaLabels]
  );

  return {
    areaLabels,
    areaSummaryLabel,
  };
}